import request from '@webtrader/core/request';

export enum EHideType {
  CATEGORY = 'CATEGORY',
  SYMBOL = 'SYMBOL'
}

export interface IHideParams {
  type: EHideType;
  values: string[];
  showAll?: boolean;
}

export interface IHideOneParams {
  type: EHideType;
  value: string;
}

export default {
  hide: (params: IHideParams) => {
    return request.post('/api/market/v1/hide', params);
  },
  hideOne: (params: IHideOneParams) => {
    return request.post('/api/market/v1/hide/one', params);
  }
};
